import styled, { keyframes } from "styled-components";
import { colors, text } from "../../theme/constants";

import * as ANIMATION from "react-animations";

const inAnimation = keyframes`${ANIMATION.flipInX}`;
// const inAnimation = keyframes`${ANIMATION.rubberBand}`;

export const WidgetContainer = styled.div`
    border-bottom: 1px solid ${colors.LAYOUT.GRAY[300]};
    color: ${colors.LAYOUT.GRAY[1000]};
    display: flex;
    flex-direction: row;
    padding: 12px;

    @media screen and (min-width: 1100px) {
        padding: 12px 0 12px 12px;
    }

    &:last-of-type {
        border-bottom: none;
    }
    animation: 500ms ${inAnimation};
`;

export const TopImage = styled.div`
    width: 48px;
    height: 48px;
    ${(props) =>
        props.transparentImage
            ? `
    background-size: contain;
    filter: drop-shadow(0px 8px 16px #00000030);
    `
            : `
    border-radius: 34px;
    background-size: cover;
    box-shadow: 0px 8px 16px #00000030;
    `}
    background-repeat: no-repeat;
    background-position: center;
    @media screen and (min-width: 480px) {
        height: 67px;
        width: 67px;
    }
    margin-right: 16px;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const Name = styled.div`
    font-family: ${text.BOLD.FONT};
    font-weight: ${text.BOLD.WEIGHT};
    font-size: 16px;
    line-height: 22px;
`;

export const Data = styled.div`
    font-family: ${text.REGULAR.FONT};
    font-weight: ${text.REGULAR.WEIGHT};
    font-size: 14px;
    line-height: 20px;
    color: ${colors.LAYOUT.GRAY[700]};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const PlusMinus = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const Amount = styled.div`
    width: 33px;
    font-family: ${text.BOLD.FONT};
    font-weight: ${text.BOLD.WEIGHT};
    font-size: 24px;
    text-align: center;
`;

export const Price = styled.div`
    font-family: ${text.BOLD.FONT};
    font-weight: ${text.BOLD.WEIGHT};
    font-size: 18px;
    line-height: 18px;
    margin-top: -8px;
`;
